import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IAccountSettingsFeature } from './account-settings.feature.state';
import { AccountSettingsState } from './account-settings.state';

export const getAccountSettingsState: MemoizedSelector<IAccountSettingsFeature, AccountSettingsState> = createFeatureSelector<AccountSettingsState>(
  nameof<IAccountSettingsFeature>('AccountSettingsFeature')
);

export const getIsLoading = createSelector(getAccountSettingsState, (state: AccountSettingsState) => state.isLoading);

export const getFailures = createSelector(getAccountSettingsState, (state: AccountSettingsState) => state.failures);

export const getSurvays = createSelector(getAccountSettingsState, (state: AccountSettingsState) => state.survays);
export const getNotifications = createSelector(getAccountSettingsState, (state: AccountSettingsState) => state.notifications);